import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AngularFireStorage } from "angularfire2/storage";
import { Observable } from "rxjs/Observable";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-upload-file",
  templateUrl: "upload-file.html",
})
export class UploadFileComponent implements OnInit {

  @Input() public form: FormControl;
  @Input() public accept: string = "image/*";
  @Input() public buttonName: string;
  @Input() public disabled: boolean = false;
  @Input() public labelName: string = null;
  @Input() public filePath: string;
  @Input() public isMultiple: boolean = false;
  @Input() public custom: boolean = false;
  @Output() public uploadCustom = new EventEmitter();
  @Output() public uploadEnd = new EventEmitter();

  public uploadPercent: Observable<number>;
  public downloadURL: Observable<string>;
  public id: string;
  public hash = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split("");

  constructor(
    private storage: AngularFireStorage,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.id = Math.floor(Math.random() * this.hash.length).toString();
  }

  public open() {
    document.getElementById(this.id).click();
  }

  public verifiedUpload(event) {
    if (this.custom) {
      this.uploadCustom.emit(event);
    } else {
      this.uploadFile(event);
    }
  }

  public clearFile(position = null) {
    this.utilities.Alert.create({
      buttons: [{
        handler: () => {
          if (position >= 0) {
            const current: string[] = this.form.value;
            if (this.isMultiple) {
              current.splice(position, 1);
              this.uploadEnd.emit(current);
              // this.form.setValue(current);
            } else {
              this.uploadEnd.emit();
              // this.form.setValue("");
            }
          } else {
            this.uploadEnd.emit();
            // this.form.setValue("");
          }
          return;
        },
        text: "Ok",
      }, {
        role: "cancel",
        text: "Cancel",
      }],
      message: "Are you sure you want to delete the current file?",
      title: "Alert",
    }).present();
  }

  public preview(image) {
    this.utilities.Modal.create("PreviewPage", { image }).present();
  }


  private async uploadFile(event) {
    const files = event.target.files;
    const promises: any[] = [];

    if (files.length > 0) {
      const load = this.utilities.setLoading();
      for (let i = 0; i < files.length; i++) {
        promises.push(await this.storage.upload(`${this.filePath}/${this.id}_${files[i].name}`, files[i]));

        if (files.length - 1 === i) {
          this.endUpload(promises, load);
        }
      }
    }
  }

  private endUpload(promises, load) {
    return Promise.all(promises)
      .then((result: any[]) => {
        if (this.isMultiple) {
          const rs: any[] = this.form.value || [];
          result.map((file) => {
            rs.push(file.downloadURL);
          });
          // this.form.setValue(rs);
          this.uploadEnd.emit(rs);
        } else {
          // this.form.setValue("");
          // this.form.setValue(result[0].downloadURL);
          this.uploadEnd.emit(result[0].downloadURL);
        }
        if (load) {
          load.dismiss();
        }
      }).catch((e) => {
        console.error("error de upload", e);
        if (load) {
          load.dismiss();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-file/upload-file.ts